import { useState } from 'react';
import { api } from '../lib/api';
import MyRequests from '../components/MyRequests';

// "Give feedback" form — single textarea + an optional topic tag for
// triage on the receiving side. Sender identity (customer, email) comes
// from the JWT, not user input. Routes to orders@silverservice.com.
const TOPICS = ['', 'Bug', 'Feature request', 'General feedback', 'Question'];
const EMPTY_FORM = { topic: '', message: '' };

export default function Feedback() {
  const [form, setForm] = useState(EMPTY_FORM);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.message.trim()) return;
    setSubmitting(true);
    setError('');
    try {
      await api.sendFeedback(form);
      setSubmitted(true);
    } catch (e) {
      setError(e.message);
    } finally {
      setSubmitting(false);
    }
  }

  if (submitted) return (
    <div style={styles.successWrap}>
      <div style={styles.successIcon}>✓</div>
      <h2 style={styles.successTitle}>Thanks!</h2>
      <p style={styles.successText}>
        Your feedback has been sent to the Silver Service team. We read everything
        and we'll follow up if a reply makes sense.
      </p>
      <button
        style={styles.backBtn}
        onClick={() => { setSubmitted(false); setForm(EMPTY_FORM); }}
      >
        Send another note
      </button>
    </div>
  );

  return (
    <div style={styles.root}>
      <div style={styles.header}>
        <h1 style={styles.title}>Give Feedback</h1>
        <p style={styles.subtitle}>
          See something off, have an idea, or just want to share a thought? We're
          all ears. Goes straight to the Silver Service team.
        </p>
      </div>

      <div style={styles.card}>
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Topic (optional)</label>
            <select style={styles.input} value={form.topic} onChange={e => set('topic', e.target.value)}>
              {TOPICS.map(t => <option key={t} value={t}>{t || '— Pick one if it helps —'}</option>)}
            </select>
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Your feedback <span style={{color:'#e74c3c'}}>*</span></label>
            <textarea
              style={{...styles.input, resize:'vertical', minHeight:160}}
              placeholder="What's on your mind? Bug reports, feature requests, broken images, weird wording — anything."
              value={form.message}
              onChange={e => set('message', e.target.value)}
              required
            />
          </div>

          {error && <div style={styles.error}>{error}</div>}

          <button style={styles.btn} type="submit" disabled={submitting || !form.message.trim()}>
            {submitting ? 'Sending…' : 'Send feedback'}
          </button>
        </form>
      </div>
      <MyRequests type="feedback" />
    </div>
  );
}

const styles = {
  root: { maxWidth: 600, margin: '0 auto' },
  header: { marginBottom:'1.5rem' },
  title: { fontSize:'1.5rem', fontWeight:700, color:'#333', margin:0 },
  subtitle: { fontSize:'0.85rem', color:'rgba(0,0,0,0.55)', margin:'0.4rem 0 0', lineHeight:1.5 },
  card: { background:'#fff', border:'1px solid #e0e0e0', borderRadius:10, padding:'2rem', boxShadow:'0 1px 3px rgba(0,0,0,0.04)' },
  form: { display:'flex', flexDirection:'column', gap:'1.25rem' },
  field: { display:'flex', flexDirection:'column', gap:'0.4rem' },
  label: { fontSize:'0.78rem', color:'rgba(0,0,0,0.5)', fontWeight:500, letterSpacing:'0.04em' },
  input: { background:'#fff', border:'1px solid #ddd', borderRadius:6, padding:'0.7rem 0.9rem', color:'#333', fontSize:'0.9rem', outline:'none', fontFamily:'inherit' },
  error: { background:'rgba(231,76,60,0.08)', border:'1px solid rgba(231,76,60,0.25)', borderRadius:6, padding:'0.75rem 1rem', color:'#c0392b', fontSize:'0.85rem' },
  btn: { background:'#A50B18', color:'#fff', border:'none', borderRadius:6, padding:'0.85rem', fontSize:'0.95rem', fontWeight:700, cursor:'pointer' },
  successWrap: { maxWidth:400, margin:'4rem auto', textAlign:'center' },
  successIcon: { width:64, height:64, background:'rgba(39,174,96,0.1)', border:'2px solid #27ae60', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 1.5rem', fontSize:'1.8rem', color:'#27ae60' },
  successTitle: { fontSize:'1.4rem', color:'#333', margin:'0 0 0.5rem' },
  successText: { color:'rgba(0,0,0,0.5)', lineHeight:1.6, margin:'0 0 2rem' },
  backBtn: { background:'none', border:'1px solid #ddd', color:'rgba(0,0,0,0.5)', borderRadius:6, padding:'0.7rem 1.5rem', cursor:'pointer', fontSize:'0.9rem' },
};
